import React from 'react';

import { Favicon } from './Favicon';
import type { TitleProps } from './Title';
import { Title } from './Title';

export interface MetaProps extends Pick<TitleProps, 'title'> {}

const Meta = ({ title }: MetaProps) => (
  <>
    <Favicon />
    <Title title={title} />
  </>
);

export { Meta };
